import { z } from 'zod';
import { syncEventSchema } from './sync-event.schemas';
import { syncMediaConfirmRequestSchema, syncMediaPresignRequestSchema } from './sync-media.schemas';

/**
 * The office recording a driver's step from the trip page (gitaumoses4/chukua#79). Each body is the driver app's own, minus the trip (it is in
 * the path) and minus the driver (the trip's current driver, never named by the caller), so the same validation applies by construction.
 */
export const officeCaptureEventSchema = syncEventSchema.omit({ tripId: true });
export type OfficeCaptureEventInput = z.infer<typeof officeCaptureEventSchema>;

/** `POST /trips/:id/driver-capture/checks`: a pre-trip check for the driver; the type is the route's, not the body's. */
export const officeCaptureCheckSchema = officeCaptureEventSchema.omit({ type: true });
export type OfficeCaptureCheckInput = z.infer<typeof officeCaptureCheckSchema>;

export const officeCaptureMediaPresignSchema = syncMediaPresignRequestSchema.omit({ tripId: true });
export type OfficeCaptureMediaPresignInput = z.infer<typeof officeCaptureMediaPresignSchema>;

export const officeCaptureMediaConfirmSchema = syncMediaConfirmRequestSchema.omit({ tripId: true });
export type OfficeCaptureMediaConfirmInput = z.infer<typeof officeCaptureMediaConfirmSchema>;

/** `duplicate`: the trip already had an event under this key with the same content, so nothing was written. */
export interface OfficeCaptureOutcome {
  outcome: 'accepted' | 'duplicate';
}

/** One step a driver's phone or the office recorded for the driver. `recordedBy` is null when the phone itself sent it. */
export interface DriverCaptureEntryView {
  id: string;
  eventType: string;
  deviceTime: string;
  serverTime: string;
  note: string | null;
  /** What the step recorded, in a line (a post-trip check's odometer, fuel and defects); null for steps with nothing beyond the note. */
  summary: string | null;
  photoCount: number;
  recordedBy: { id: string; name: string } | null;
  driver: { id: string; name: string } | null;
}
